<template>
  <div class="prize-carousel" :class="{
    'prize-carousel--small': smallDisplay
  }">
    <NinjaFrame
      ref="frame"
      class="prize-carousel__wrapper"
      :triggered="imagesLoaded"
      :horizonalDisplay="smallDisplay"
      @change="handleSlideChange"
      @busy="handleBusy"
    >
    <div
        class="prize-carousel__item"
        v-for="(image, i) in images"
        :key="image"
        :style="{
          backgroundImage: `url(${image})`,
        }"
        v-show="i === activeIndex"
      />
    </NinjaFrame>
    <CarouselInterface
      class="prize-carousel__carousel-interface"
      :itemCount="itemCount"
      @slideChange="updateDirection"
      :currentIndex="activeIndex"
      :autoAdvance="imagesLoaded"
      :heroHorizontal="smallDisplay"
      :prizesVersion="true"
    />
  </div>
</template>

<script>
/**
 * carousel component in the prize section
 */
import CarouselInterface from './carousel-interface';
import NinjaFrame from './../components/ninja-frame';
import ImagePreload from '../core/image-preload';
import CheckRef from './../mixins/check-ref';


export default {
  name: 'prize-carousel',
  mixins: [CheckRef],
  components: {
    CarouselInterface,
    NinjaFrame,
  },
  props: {
    smallDisplay: {
      type: Boolean,
      default: false,
    },
    listIndex: {
      type: Number
    },
    images: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      direction: '',
      leaving: false,
      ready: true,
      isAnimating: false,
      activeIndex: 0,
      timeouts: [],
      imagesLoaded: false,
    };
  },
  mounted() {
    new ImagePreload(this.images)
      .load()
      .then(() => {
        this.imagesLoaded = true;
      });
  },
  computed: {
    /**
     * Number of images
     * @returns {Number}
     */
    itemCount() {
      return this.images.length;
    },

    containerItemBackground() {
      // :src="images[activeIndex]"
      return {
        backgroundImage: `url(${this.images[this.activeIndex]})`,
      };
    },
  },
  methods: {
    /**
     * increment the index of the current slide
     *
     * @param {String} direction - prev or next
     * @param {Number} index - optional for when a list item number is clicked
     */
    handleSlideChange(direction, index = null) {
      if (index !== null) {
        this.activeIndex = index;
        this.$emit('slideChange', index);
        return;
      }
      if (direction === 'next') {
        if (this.activeIndex === this.itemCount - 1) {
          this.activeIndex = 0;
        } else {
          this.activeIndex += 1;
        }
      } else if (this.activeIndex === 0) {
        this.activeIndex = this.itemCount - 1;
      } else {
        this.activeIndex -= 1;
      }
      this.$emit('slideChange', this.activeIndex);
    },
    handleBusy(busy) {
      this.$emit('busy', busy);
    },
    updateDirection(direction, index = null) {
      const frame = this.checkRef('frame');

      frame.animateSlideChange(direction, index);
    },
  },
  beforeDestroy() {
    // clean all timeouts
    this.timeouts.forEach(timeout => window.clearTimeout(timeout));
  },
  watch: {
    listIndex(val) {
      this.updateDirection('next', val);
    },
  }
};
</script>

<style lang="scss">

$time-transition-prize-carousel-transition-slide: 400ms;
$time-transition-prize-carousel-transition-delay: 100ms;

.prize-carousel {
  &__wrapper {
    position: relative;
    &::before {
      content: '';
      display: block;
      padding-bottom: percentage($number: $submission-thumbnail-ratio);
    }
    overflow: hidden;
    max-width: $size-max-width-prize-carousel-container-large;
  }
  &__carousel-interface {
    margin-top: $size-margin-top-prize-carousel-carousel-interface-large;
  }
  &--small {
    max-width: $size-max-width-prize-carousel-container-small;
    margin: {
      left: auto;
      right: auto;
    }
    .prize-carousel {

      &__wrapper {
        // not a media query because more than styles changes at breakpoint
        &::before {
          padding-bottom: percentage($number: 1 / $submission-thumbnail-ratio);
        }
        max-width: none;

      }

      &__carousel-interface {
        margin-top: $size-margin-top-prize-carousel-carousel-interface-small;
      }
    }
  }

  .ninja-frame__container__item {
    display: flex;
    justify-content: center;
    align-content: center;
  }

   .prize-carousel__item {
    // margin: 0;
    flex: 1 1 auto;
        background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  }
}
</style>
